(function () {
  'use strict';

  var STORAGE_KEY = 'age_verified_at';
  var EXPIRY_MS = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

  function isVerified() {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) return false;
      var timestamp = parseInt(stored, 10);
      if (isNaN(timestamp)) return false;
      return Date.now() - timestamp < EXPIRY_MS;
    } catch (e) {
      // localStorage unavailable (private mode, etc.) — show gate every time
      return false;
    }
  }

  function setVerified() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {
      // Ignore storage errors
    }
  }

  function showOverlay() {
    var overlay = document.getElementById('age-verification-overlay');
    if (!overlay) return;
    overlay.classList.remove('age-verification--hidden');
    // Prevent background scrolling while gate is visible
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    overlay.setAttribute('aria-hidden', 'false');
  }

  function hideOverlay() {
    var overlay = document.getElementById('age-verification-overlay');
    if (!overlay) return;
    overlay.classList.add('age-verification--hidden');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    overlay.setAttribute('aria-hidden', 'true');
  }

  function onConfirm() {
    setVerified();
    hideOverlay();
  }

  function onDecline() {
    // Redirect away from site — visitor is under 18
    window.location.replace('https://www.google.com.au');
  }

  function init() {
    // Skip entirely when in the Shopify theme editor or storefront preview
    if (window.Shopify && window.Shopify.designMode) return;

    var overlay = document.getElementById('age-verification-overlay');
    if (!overlay) return;

    if (isVerified()) {
      // Already verified within last 24 hours — keep gate hidden
      overlay.classList.add('age-verification--hidden');
      overlay.setAttribute('aria-hidden', 'true');
      return;
    }

    // Needs verification — show the gate
    showOverlay();

    var confirmBtn = document.getElementById('age-verification-confirm');
    var declineBtn = document.getElementById('age-verification-decline');

    if (confirmBtn) {
      confirmBtn.addEventListener('click', onConfirm);
    }

    if (declineBtn) {
      declineBtn.addEventListener('click', onDecline);
    }

    // Trap focus inside dialog while overlay is visible
    overlay.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusable = overlay.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    // Set initial focus to confirm button
    if (confirmBtn) {
      confirmBtn.focus();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
